import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import { MatFormField } from '@angular/material/form-field';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppState } from 'src/app/app.reducer';
import { RoleOption } from 'src/app/pages/role-register/models/role-option.interface';
import { NgrxEagerSelectService } from '../../select/eager-select/ngrx-eager-select-status.service';
import { LcsSingleSelectDirective } from '../../single-select/single-select.directive';
import { roleOptionActions } from '../state/role-option.actions';
import { roleOptionSelectors } from '../state/role-option.reducer';

@Directive({
    selector: '[ndtRoleSelect]',
    standalone: false
})
export class RoleSelectInputDirective implements OnDestroy, AfterViewInit {
   @Input() accountId: number | null;

   @Input() additionalFields: string[] | null;

   @Input() urlOverride?: string;

   @Input() isOnSystemPage = false;

   private destroyed$ = new Subject<void>();

   constructor(
      private elementRef: ElementRef,
      private formField: MatFormField,
      private trigger: LcsSingleSelectDirective<RoleOption>,
      private statusService: NgrxEagerSelectService<AppState, RoleOption>
   ) {}

   ngAfterViewInit(): void {
      let staticFilterOverride: string[] | undefined;

      if (this.isOnSystemPage) {
         staticFilterOverride = [`AccountId is null`];
      } else if (this.accountId) {
         staticFilterOverride = [`AccountId = ${this.accountId}`];
      }

      this.statusService
         .initialize(
            this.formField,
            this.trigger,
            this.elementRef.nativeElement,
            roleOptionActions,
            roleOptionSelectors,
            () => {
               return this.additionalFields;
            },
            () => {
               return this.urlOverride;
            },
            () => {
               return this.statusService.buildPrimaryKeyFilterExpression('roleId', this.trigger);
            },
            staticFilterOverride
         )
         .pipe(takeUntil(this.destroyed$))
         .subscribe();
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }
}
